/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

// Material Kit 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Material Kit 2 React page layout routes
import routes from "routes";

// Images
import gsbLogoImage from "assets/images/logo-gsb.png";

// api
import { encryptGCM } from "api/crypto";
import { auth } from "api/auth";

function SignInBasic() {
  const navigate = useNavigate();
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [isAuthFailed, setAuthFailed] = useState(false);
  const [msgAuthFailed, setMsgAuthFailed] = useState(null);

  const handleAuth = async (e) => {
    e.preventDefault();
    if (username && password) {
      const passwordEncrypted = await encryptGCM({ value: password });
      const payload = {
        username: username,
        password: passwordEncrypted.encrypted,
      };
      const response = await auth(payload);
      if (response.status_flag) {
        if (response.user.isAdmin) {
          navigate("/ndrs/admin", { state: { user: response.user } });
        } else if (response.user.isCallCenter) {
          navigate("/ndrs/importCallcenter", { state: { user: response.user } });
        } else if (response.user.isIt) {
          navigate("/ndrs/exportAndImportCallcenter", { state: { user: response.user } });
        } else {
          setAuthFailed(true);
          setMsgAuthFailed("ไม่พบสิทธิ์เข้าใช้งาน");
        }
      } else {
        setAuthFailed(true);
        setMsgAuthFailed("ไม่พบสิทธิ์เข้าใช้งาน");
      }
    } else {
      setAuthFailed(true);
      setMsgAuthFailed("Username หรือ Password ไม่ถูกต้อง");
    }
  };
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://ln15.gsb.or.th/ndrs",
          label: "GSB NDRS Website",
          color: "default",
        }}
        transparent
        light
      />
      <MKBox
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        bgColor="#1e88e5"
        coloredShadow="#1e88e5"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <Card>
              <MKBox
                variant="contained"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MKBox
                  component="img"
                  src={gsbLogoImage}
                  alt={"GSB LOGO"}
                  width="18%"
                  borderRadius="md"
                  shadow="lg"
                  textAlign="center"
                />
                <MKTypography variant="h6" fontWeight="medium" color="primary" mt={1}>
                  ข้อมูลลูกค้าที่ลงทะเบียนเข้าร่วมมาตรการผ่อนปรนเงื่อนไขการชำระหนี้
                  <br />
                  มาตรการให้ความช่วยเหลือลูกหนี้ที่มีสถานะเป็นหนี้เสียที่มีภาระหนี้เงินต้นและดอกเบี้ยไม่เกิน
                  1 แสนบาท
                </MKTypography>
              </MKBox>
              <MKBox pt={4} pb={3} px={3}>
                <MKBox component="form" role="form">
                  <MKBox mb={2}>
                    <MKInput
                      type="text"
                      color="primary"
                      label="Username"
                      autoComplete="off"
                      onChange={(e) => setUsername(e.target.value)}
                      fullWidth
                    />
                  </MKBox>
                  <MKBox mb={2}>
                    <MKInput
                      type="password"
                      color="primary"
                      label="Password"
                      autoComplete="off"
                      onChange={(e) => setPassword(e.target.value)}
                      fullWidth
                    />
                  </MKBox>
                  <MKBox mt={4} mb={1}>
                    <MKButton variant="gradient" color="primary" onClick={handleAuth} fullWidth>
                      Login
                    </MKButton>
                    {isAuthFailed ? (
                      <MKTypography variant="caption" fontWeight="medium" color="error">
                        {msgAuthFailed}
                      </MKTypography>
                    ) : null}
                  </MKBox>
                </MKBox>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
    </>
  );
}

export default SignInBasic;
